import React, { ReactElement } from 'react';

type AddressCardProps = {
    cardTitle: string;
    address: any;
    linkLabel?: string;
    onClick?: () => void;
    isBoss?: boolean
}

const AddressCard = (props: AddressCardProps) : ReactElement => {

    const {
        cardTitle,
        address,
        linkLabel,
        onClick,
        isBoss
    } = props;

    return(
        <div className="address-card">
            <div className="address-card-header">
                <label className="address-card-header-label">{cardTitle}</label>
                {!!linkLabel && !!onClick && <button className="primary-button" onClick={onClick}>{linkLabel}</button>}
            </div>
            <div className="address-card-content">
                <div className="address-card-content-address">
                    {address.firstName +" "+ address.lastName +", "}
                    {isBoss ? address.email1 : address.address1 +" "+ address.city +", "+ address.state +" "+ address.zipCode}
                </div>
                <div className="address-card-content-phone">
                    {address.phone1}
                </div>
            </div>
        </div>
    )
}

export default AddressCard;